import React from 'react';

export default () => {
  return <React.Fragment>
    <h2>WebToolbox</h2>
    <span>Simple tools for development.</span>
  </React.Fragment>;
}
